import { Grid } from '@mui/material';
import { HSpacer, RoutalDialog, RoutalInputText, RoutalPalette } from '@nx-smartmonkey/ui';

import { useState } from 'react';
import Button from '../react-components/Button';
import Text from '../react-components/Text';

type ConfirmDeleteDialogProps<T> = {
  open: boolean;
  data: T[];
  typeData: `plans` | `services` | `routes` | `clients` | `vehicles` | `geo_fences` | `supervisors` | `tasks`;
  loading?: boolean;
  confirmInputValue?: string; // If present, confirm input is required
  onCloseDialog: () => any;
  handleDelete: () => any;
};

export const ConfirmDeleteDialog = <T,>({
  open,
  data,
  typeData,
  loading,
  confirmInputValue,
  onCloseDialog,
  handleDelete,
}: ConfirmDeleteDialogProps<T>) => {
  const [confirmInputText, setConfirmInputText] = useState(``);

  const isEnabled = () =>
    confirmInputValue === undefined ||
    confirmInputValue.toLowerCase() === confirmInputText.replaceAll(`"`, ``).toLowerCase();

  return (
    <RoutalDialog
      open={open}
      onCloseDialog={() => {
        if (!loading) onCloseDialog();
      }}
      titleContent={<Text variant="h6" intlId={`${typeData}.delete_dialog.title`} />}
      footerContent={
        <Grid container justifyContent="flex-end">
          <Button
            id="delete_dialog.confirm"
            variant="flat"
            onClick={() => onCloseDialog()}
            intlId={`${typeData}.delete_dialog.cancel`}
            disabled={loading}
          />
          <HSpacer large />
          <Button
            id="delete_dialog.delete"
            disabled={loading || !isEnabled()}
            onClick={() => {
              handleDelete();
            }}
            intlId={`${typeData}.delete_dialog.confirm`}
            style={{
              backgroundColor: RoutalPalette.button.danger.defaultColor,
            }}
          />
        </Grid>
      }
    >
      <Grid container direction="column" gap="8px">
        <Grid container direction="row" gap="2px">
          <Text
            tagName="span"
            intlId={`${typeData}.delete_dialog.body`}
            intlValues={{ data: Array.isArray(data) ? data.length : `1` }}
          />
          {confirmInputValue && (
            <Text tagName="span" intlId="delete_dialog.type_confirm" intlValues={{ confirm: confirmInputValue }} />
          )}
        </Grid>

        {confirmInputValue && (
          <RoutalInputText
            fullWidth
            onChange={(value) => {
              setConfirmInputText(value);
            }}
            fieldValue={confirmInputText}
            placeholder={confirmInputValue}
          />
        )}
      </Grid>
    </RoutalDialog>
  );
};
